import * as React from 'react'

import LoadingSpinner from '../icons/loadingSpinner'

import * as styles from './loadingCover.module.css'

const LoadingCover = () => {
  return (
    <div className={styles.root}>
      <LoadingSpinner />
    </div>
  )
}

export default LoadingCover
